import axios from 'axios'

// 列表
export function getList () {
  return axios({
    url: this.pageUrl + '/query',
    method: 'post',
    data: Object.assign({}, this.formQuery, this.pageParam)
  })
}

// 导出
export function getExport (fileType) {
  return axios({
    url: this.pageUrl + '/export/' + fileType,
    method: 'post',
    data: Object.assign({}, this.formQuery, this.pageParam),
    responseType: 'blob'
  })
}

// 导入
export function getImportTemplate () {
  return axios({
    url: this.pageUrl + '/importTemplate',
    method: 'get',
    responseType: 'blob'
  })
}

// 详情
export function getDetail (data) {
  return axios({
    url: this.pageUrl + '/' + data[this.idName],
    method: 'get'
  })
}

// 添加
export function getAdd () {
  return axios({
    url: this.pageUrl,
    method: 'post',
    data: this.formAdd
  })
}

// 编辑
export function getEdit () {
  return axios({
    url: this.pageUrl,
    method: 'put',
    data: this.formEdit
  })
}

// 删除
export function getDelete (data) {
  return axios({
    url: this.pageUrl + '/' + data[this.idName],
    method: 'delete'
  })
}

// 批量删除
export function getBatchDelete () {
  return axios({
    url: this.pageUrl,
    method: 'delete',
    data: {
      ids: this.dataSelectList
    }
  })
}

// 启用
export function getEnable (data) {
  return axios({
    url: this.pageUrl + '/enable/' + data[this.idName],
    method: 'post'
  })
}

// 禁用
export function getDisable (data) {
  return axios({
    url: this.pageUrl + '/disable/' + data[this.idName],
    method: 'post'
  })
}

// 批量启用
export function getBatchEnable (ids) {
  return axios({
    url: this.pageUrl + '/enable',
    method: 'post',
    data: {
      ids
    }
  })
}

// 批量禁用
export function getBatchDisable (ids) {
  return axios({
    url: this.pageUrl + '/disable',
    method: 'post',
    data: {
      ids
    }
  })
}

export function getCheckPass (data) {
  return axios({
    url: this.pageUrl + '/checkPass/' + data[this.idName],
    method: 'post'
  })
}

export function getCheckRefuse (data) {
  return axios({
    url: this.pageUrl + '/checkRefuse',
    method: 'post',
    data
  })
}

export function getBatchCheckPass (ids) {
  return axios({
    url: this.pageUrl + '/checkPass',
    method: 'post',
    data: {
      ids
    }
  })
}
